import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        cardContent: {
            height: 720,
            marginTop: theme.spacing(3),
        },
        inbound: {
            background: theme.palette.primary[200],
        },
        outbound: {
            background: theme.palette.primary[700],
        },
        headerWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        linkWrapper: {
            padding: 0,
        },
    }
})

export default useStyles
